import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  HomeOutlined, AlertOutlined, SolutionOutlined, AuditOutlined,
} from '@ant-design/icons';
import IcpFooter from '../components/IcpFooter';
import '../pages/mobile/mobile.css';

const TABS = [
  { key: '/m', icon: <HomeOutlined />, label: '首页' },
  { key: '/m/alarms', icon: <AlertOutlined />, label: '告警' },
  { key: '/m/tasks', icon: <SolutionOutlined />, label: '工单' },
  { key: '/m/inspection', icon: <AuditOutlined />, label: '巡检' },
];

export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('qhy_user') || '{}');

  const activeKey = TABS.find((t) => location.pathname === t.key
    || (t.key !== '/m' && location.pathname.startsWith(t.key)))?.key || '/m';

  return (
    <div className="mobile-shell">
      <div className="mobile-header">
        <h1>黔好运运维</h1>
        <p>{user.name || user.username || '运维人员'} · 现场运维小程序</p>
      </div>
      <div className="mobile-content">
        <Outlet />
      </div>
      <IcpFooter style={{ padding: '4px 0', fontSize: 11 }} />
      <div className="mobile-tabbar">
        {TABS.map((tab) => (
          <div
            key={tab.key}
            className={`mobile-tabbar-item ${activeKey === tab.key ? 'active' : ''}`}
            onClick={() => navigate(tab.key)}
          >
            <span className="icon">{tab.icon}</span>
            {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
}
